module.exports = __webpack_public_path__ + "img/hipster_black_top-120x156.57c15c4e.jpg";